"use client";

import { useCategory } from "@/features/media-center/hooks/use-category";

import { useUserBehavior } from "../../services/get-user-behavior";

export const ProgressBar = ({ mediaId }: { mediaId: string }) => {
  const { category } = useCategory();
  const { data, isLoading, isError } = useUserBehavior({ category });

  if (isLoading || isError) return null;

  const progress = new Intl.NumberFormat("en-US", {
    style: "percent",
  }).format(data[mediaId]?.progress ?? 0);

  return (
    <div className="flex items-center justify-between gap-5">
      <span className="relative h-2 w-full rounded-full bg-zinc-200">
        <span
          style={{
            width: progress,
          }}
          className="absolute left-0 top-0 h-2 rounded-full bg-gradient-to-r from-[#0369A1] to-[#0EA5E9]"
        />
      </span>
      <span>{progress}</span>
    </div>
  );
};
